module.exports = __webpack_public_path__ + "img/Ninja-Panda-Esport-Logo-Template.jpg";